import React, {useState, useEffect} from 'react';
import Pagination from 'react-js-pagination';
import {useSelector} from 'react-redux';
import {NavLink, useHistory, useLocation} from 'react-router-dom';
import Table from 'react-bootstrap/Table';
import {toast} from 'react-toastify';
import {useMutation, useQuery} from 'react-query';
import {Image} from 'react-bootstrap';
import {AsyncPaginate} from 'react-select-async-paginate';
import {
    DISEASE_API,
    DONVIDENGHI_API,
    BaseGatewayImage,
    ACCOUNT_API
} from '@app/utils/apiUrl.js';
import {DeleteSingle, Get} from '@app/utils/httpProvider';
import {
    createUrlWithParam,
    formatDateTimeCrawler,
    formatDateTimeMoment,
    formatDateTimeWithoutHour,
    formatDateTimeWithoutHourMoment,
    getInfomationAccountFromToken,
    isValidUrl
} from '../../utils/helper';
import {URI_INTERNAL} from '../../utils/pathLocations';
import {
    objectShowNumber,
    messageToast,
    objectDeviceStatus,
    deviceStatus,
    styleSelectDefault,
    role,
    objectTrangThaiDeNghi,
    trangThaiDeNghiValue
    // sortByValue
} from '../../utils/define';
import {ConfirmModal} from '../../modules/modal/ConfirmModal';
import {BrowserView, MobileView} from 'react-device-detect';
import Select from 'react-select';

// import { motion, AnimatePresence } from 'framer-motion';
// import { motion, AnimatePresence } from 'framer-motion/dist/framer-motion.cjs.js';
import {AnimatePresence, motion} from 'framer-motion/dist/framer-motion';
import DiseaseEdit from '@app/pages/disease/DiseaseEdit';

const Disease = () => {
    const history = useHistory();
    const location = useLocation();
    const valueSearch = useSelector((state) => state.search.valueSearch);

    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [search, setSearch] = useState('');

    const [openConfirmDeleteModal, setOpenConfirmDeleteModal] = useState(false);
    const [idWantDelete, setIdWantDelete] = useState('');
    const [confirmDelMessage, setConfirmDelMessage] = useState('');
    const [accountPatientId, setAccountPatientId] = useState('');

    // let accountRoleAdmin = false;
    // const inforAccount = getInfomationAccountFromToken();

    // if (inforAccount && inforAccount.role) {
    //     const userRole = inforAccount.role.split(', ');
    //     accountRoleAdmin =
    //         userRole.includes(role.Admin) || userRole.includes(role.Doctor);
    // }

    const deleteFunc = useMutation((value) =>
        DeleteSingle(DISEASE_API.DELETE_ITEM, value, null)
    );

    const paramUrl = new URLSearchParams(location.search.substring(1));
    if (
        paramUrl.get('page') != null &&
        parseInt(paramUrl.get('page'), 10) !== page
    ) {
        const pageResult = parseInt(paramUrl.get('page'), 10);
        setPage(pageResult);
    }
    if (
        paramUrl.get('size') != null &&
        parseInt(paramUrl.get('size'), 10) !== pageSize
    ) {
        const sizeResult = parseInt(paramUrl.get('size'), 10);
        setPageSize(sizeResult);
    }
    if (paramUrl.get('search') != null && paramUrl.get('search') !== search) {
        setSearch(paramUrl.get('search'));
    }

    // const [isSortedNameAlphabet, setIsSortedNameAlphabet] = useState(false);

    const {isLoading, isError, error, data, refetch} = useQuery(
        ['diseaseData', valueSearch, page, pageSize],
        () => {
            let model = {
                Keyword: valueSearch ? valueSearch : '',
                PageIndex: page,
                PageSize: pageSize,
                AccountPatientId:
                    accountPatientId &&
                    accountPatientId.target &&
                    accountPatientId.target.value
                        ? accountPatientId.target.value.value
                        : ''
            };

            return Get(DISEASE_API.GET_PAGING, null, model);
        }
    );

    useEffect(() => {
        refetch();
    }, [pageSize, page, accountPatientId]);

    const replaceHistory = async (Page, Size, Search) => {
        history.replace(
            createUrlWithParam(URI_INTERNAL.DISEASE_PATH, {
                page: Page,
                size: Size,
                search: Search
            })
        );
    };

    React.useEffect(() => {
        if (valueSearch != null && valueSearch !== search) {
            replaceHistory(1, pageSize, valueSearch);
        }
    }, [valueSearch]);

    const changePage = (number) => {
        setPage(number);
        replaceHistory(number, pageSize, search);
    };

    const onChangeShowNumber = (e) => {
        setPageSize(e.target.value);
        replaceHistory(page, e.target.value, search);
    };

    const deleteAction = (id, name) => {
        setIdWantDelete(id);
        setConfirmDelMessage(name);
        setOpenConfirmDeleteModal(true);
    };

    const acceptDelete = async () => {
        if (idWantDelete !== '') {
            deleteFunc.mutate(idWantDelete, {
                onSuccess: (res) => {
                    if (res.status === 201 || res.status === 200) {
                        refetch();
                        toast.success(messageToast.messageToastDeleteSuccess);
                        if (
                            data != null &&
                            data.data.length === 1 &&
                            page !== 1
                        ) {
                            history.push(
                                createUrlWithParam(URI_INTERNAL.DISEASE_PATH, {
                                    page: page - 1,
                                    size: pageSize,
                                    search: search
                                })
                            );
                        }
                    } else {
                        toast.error(messageToast.messageToastDeleteError);
                    }
                },
                onError: (res) => {
                    toast.error(messageToast.messageToastTryCatch);
                }
            });

            replaceHistory(page, pageSize, search);
            setOpenConfirmDeleteModal(false);
        }
    };

    const cancelDelete = () => {
        setIdWantDelete('');
        setOpenConfirmDeleteModal(false);
    };

    // const listAccountPatient = useQuery(['getAllAccountPatient'], () =>
    //     Get(ACCOUNT_API.GET_PAGING_ACCOUNT, null, {
    //         PageIndex: 1,
    //         PageSize: 10000,
    //         Keyword: '',
    //         Role: role.Patient
    //         // DeviceStatus: deviceStatus.available
    //     })
    // );

    // // Khoa
    // const lstAccountPatient =
    //     listAccountPatient &&
    //     listAccountPatient.data &&
    //     listAccountPatient.data.data
    //         ? listAccountPatient.data.data.map((x) => ({
    //               label: x.ten,
    //               value: x.id
    //           }))
    //         : [];

    const loadOptions = async (search, loadedOptions, {page}) => {
        // const filteredOptions = lstAccountPatient
        //     .filter((option) =>
        //         option.label.toLowerCase().includes(inputValue.toLowerCase())
        //     )
        //     .slice(0, 6);

        // // Return all filtered options, no matter how many there are
        // return {
        //     options: filteredOptions,
        //     hasMore: false,
        //     additional: {
        //         page: page + 1
        //     }
        // };
        const pageSize = 10;
        const res = await Get(ACCOUNT_API.GET_PAGING_ACCOUNT, null, {
            PageIndex: page,
            PageSize: pageSize,
            Role: role.Patient,
            Keyword: search // pass the input text to filter server-side
        });

        const data = res.data || [];
        const options = data.map((x) => ({
            label: `${x.fullName} – ${x.username}`,
            value: x.id
        }));

        // assume your API returns total count or a flag for more pages
        const hasMore = data.length === pageSize;
        return {
            options,
            hasMore,
            additional: {page: page + 1}
        };
    };

    const [editingItem, setEditingItem] = useState(null);

    return (
        <div className="container-fluid">
            
            <div className="row">
                {/* <motion.div
          className={editingItem ? 'col-lg-8' : 'col-lg-12'}
          layout
          style={{ overflow: 'hidden' }}
        > */}
                <div className="col-lg-12">
                    <div className="card">
                        <div className="card-header">
                            <h3 className="card-title"> Danh sách bệnh lý</h3>
                        </div>
                        <div className="card-body">
                            <div className="d-flex justify-content-between">
                                <form className="form-inline">
                                    <label
                                        htmlFor="exampleEmail2"
                                        className="mr-2"
                                    >
                                        Hiển thị :
                                    </label>
                                    <select
                                        className="form-control"
                                        value={pageSize}
                                        onChange={(e) => onChangeShowNumber(e)}
                                    >
                                        {objectShowNumber.map((item, key) => (
                                            <option
                                                key={Number(key)}
                                                value={item.value}
                                            >
                                                {item.text}
                                            </option>
                                        ))}
                                    </select>

                                    <span style={{marginLeft: '20px'}}>
                                        <AsyncPaginate
                                            name="accountPatientId"
                                            id="accountPatientId"
                                            placeholder="Chọn bệnh nhân"
                                            value={accountPatientId.value}
                                            loadOptions={loadOptions}
                                            styles={styleSelectDefault}
                                            isClearable
                                            onChange={(selectedOption) => {
                                                const event = {
                                                    target: {
                                                        name: 'accountPatientId',
                                                        value: selectedOption
                                                    }
                                                };
                                                setAccountPatientId(event);
                                            }}
                                            additional={{
                                                page: 1
                                            }}
                                        />
                                    </span>
                                </form>
                                <NavLink
                                    className="nav-link-reject nav-link"
                                    to={URI_INTERNAL.DISEASE_CREATE_PATH}
                                >
                                    <button
                                        type="button"
                                        className="btn btn-info"
                                    >
                                        Thêm mới
                                    </button>
                                </NavLink>
                            </div>

                            {isLoading ? (
                                <div>Đang tải...</div>
                            ) : isError ? (
                                <div>Có lỗi xảy ra: ${error.message}</div>
                            ) : (
                                <div
                                    id="example2_wrapper"
                                    className="dataTables_wrapper dt-bootstrap4"
                                    // style={{
                                    //     marginTop: accountRoleAdmin
                                    //         ? '0px'
                                    //         : '20px'
                                    // }}
                                >
                                    <div className="row">
                                        <div
                                            className="col-sm-12"
                                            style={{overflow: 'auto'}}
                                        >
                                            
                                                {/* — Phần danh sách (co lại khi mở form) — */}
                                                {/* <motion.div
                                                    style={{flexShrink: 0}}
                                                    animate={{
                                                        width: editingItem
                                                            ? '60%'
                                                            : '100%'
                                                    }}
                                                    transition={{duration: 0.3}}
                                                > */}
                                                    <Table
                                                        striped
                                                        bordered
                                                        hover
                                                    >
                                                        <thead>
                                                            <tr role="row">
                                                                <th className="sorting">
                                                                    STT
                                                                </th>
                                                                <th className="sorting">
                                                                    Tên bệnh lý
                                                                </th>
                                                                <th className="sorting">
                                                                    Mô tả
                                                                </th>
                                                                <th className="sorting">
                                                                    Chức năng
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        {data != null &&
                                                        data.data != null &&
                                                        data.data != null &&
                                                        data.data !==
                                                            undefined &&
                                                        data.data.length > 0 ? (
                                                            <tbody>
                                                                {data.data.map(
                                                                    (
                                                                        item,
                                                                        index
                                                                    ) => (
                                                                        <tr
                                                                            key={Number(
                                                                                index
                                                                            )}
                                                                            className="odd"
                                                                        >
                                                                            <td className="dtr-control sorting_1">
                                                                                {index +
                                                                                    1 +
                                                                                    (page -
                                                                                        1) *
                                                                                        pageSize}
                                                                            </td>
                                                                            <td>
                                                                                {
                                                                                    item.name
                                                                                }
                                                                            </td>
                                                                            <td>
                                                                                <div className="desc style-desc">
                                                                                    <span
                                                                                        dangerouslySetInnerHTML={{
                                                                                            __html: item.description
                                                                                        }}
                                                                                    />
                                                                                </div>
                                                                            </td>
                                                                            <td>
                                                                                <ul className="nav">
                                                                                    <li className="nav-item">
                                                                                        <NavLink
                                                                                            to={createUrlWithParam(
                                                                                                URI_INTERNAL.DISEASE_EDIT_PATH,
                                                                                                {
                                                                                                    id: item.id
                                                                                                }
                                                                                            )}
                                                                                            exact
                                                                                            className="nav-link"
                                                                                        >
                                                                                            <i
                                                                                                title="Sửa"
                                                                                                className="nav-icon font-icon fas fa-pen"
                                                                                            />
                                                                                        </NavLink>
                                                                                    </li>
                                                                                    {/* <li className="nav-item">
                                                                                        <button
                                                                                            className="btn btn-sm btn-outline-primary mr-2"
                                                                                            onClick={() =>
                                                                                                setEditingItem(
                                                                                                    item
                                                                                                )
                                                                                            }
                                                                                        >
                                                                                            <i className="fas fa-pen" />{' '}
                                                                                            Sửa
                                                                                        </button>
                                                                                    </li> */}
                                                                                    {/* <li className="nav-item">
                                                                                <NavLink
                                                                                    to={createUrlWithParam(
                                                                                        URI_INTERNAL.DISEASE_ADD_PATIENT_PATH,
                                                                                        {
                                                                                            id: item.id
                                                                                        }
                                                                                    )}
                                                                                    exact
                                                                                    className="nav-link"
                                                                                >
                                                                                    <i
                                                                                        title="Thêm bệnh nhân"
                                                                                        className="nav-icon font-icon fas fa-plus"
                                                                                    />
                                                                                </NavLink>
                                                                            </li> */}
                                                                                    <li className="nav-item">
                                                                                        <NavLink
                                                                                            onClick={() =>
                                                                                                deleteAction(
                                                                                                    item.id, item.name
                                                                                                )
                                                                                            }
                                                                                            to
                                                                                            exact
                                                                                            className="nav-link"
                                                                                        >
                                                                                            <i
                                                                                                title="Xóa"
                                                                                                className="nav-icon font-icon far fa-trash-alt"
                                                                                            />
                                                                                        </NavLink>
                                                                                    </li>
                                                                                </ul>
                                                                            </td>
                                                                        </tr>
                                                                    )
                                                                )}
                                                            </tbody>
                                                        ) : (
                                                            <tbody>
                                                                <tr className="txt-center">
                                                                    <td colSpan="12">
                                                                        Không có
                                                                        dữ liệu
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        )}
                                                        <tfoot>
                                                            <tr role="row">
                                                                <th className="sorting">
                                                                    STT
                                                                </th>
                                                                <th className="sorting">
                                                                    Tên bệnh lý
                                                                </th>
                                                                <th className="sorting">
                                                                    Mô tả
                                                                </th>
                                                                <th className="sorting">
                                                                    Chức năng
                                                                </th>
                                                            </tr>
                                                        </tfoot>
                                                    </Table>
                                                {/* </motion.div> */}

                                                
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div
                                                className="dataTables_paginate paging_simple_numbers"
                                                id="example2_paginate"
                                            >
                                                <Pagination
                                                    itemClass="page-item"
                                                    linkClass="page-link"
                                                    innerClass="pagination pagination-sm no-margin pull-right"
                                                    activePage={page}
                                                    itemsCountPerPage={Number(
                                                        pageSize
                                                    )}
                                                    totalItemsCount={
                                                        data != null
                                                            ? data.totalRecords
                                                            : 0
                                                    }
                                                    pageRangeDisplayed={5}
                                                    onChange={(number) =>
                                                        changePage(number)
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                           
                            <ConfirmModal
                                isOpen={openConfirmDeleteModal}
                                confirmType="delete"
                                handleAccept={() => acceptDelete()}
                                handleCancel={() => cancelDelete()}
                                content={confirmDelMessage}
                            />
                        </div>
                    </div>
                </div>
                {/* </motion.div> */}

                 {/* Right: edit panel */}
       {/* Right: edit panel */}
        {/* <AnimatePresence initial={false} exitBeforeEnter>
          {editingItem && (
            <motion.div
              className="col-lg-4"
              layout
              initial={{ x: '100%' }}
              animate={{ x: 0 }}
              exit={{ x: '100%' }}
              transition={{ duration: 0.3 }}
              style={{ position: 'absolute', top: 0, right: 0, bottom: 0, padding: 0, background: '#fff' }}
            >
              <div className="card h-100">
                <div className="card-body position-relative">
                  <button
                    onClick={() => setEditingItem(null)}
                    style={{ position: 'absolute', top: 10, right: 10, border: 'none', background: 'transparent', fontSize: '1.5rem' }}
                  >&times;</button>
                  <h5 className="mb-4">Sửa bệnh lý</h5>
                  <DiseaseEdit
                    item={editingItem}
                    onSaved={() => { refetch(); setEditingItem(null); }}
                    onCancel={() => setEditingItem(null)}
                  />
                </div>
              </div>
            </motion.div>
          )}
        </AnimatePresence> */}
            </div>
        </div>
    );
};

export default Disease;
